export const isLoadingPaymentMethodAuthorizationToken = state =>
  state.paymentMethods.isLoading || !state.paymentMethods.authorizationToken;

export const getPaymentMethodAuthorizationToken = state =>
  state.paymentMethods.authorizationToken;

export const isUpdatingPaymentMethod = state => state.paymentMethods.isUpdating;
export const hasUpdatedPaymentMethod = state => state.paymentMethods.hasUpdated;



// WEBPACK FOOTER //
// ./src/store/paymentMethods/selectors.js